export const SMART_REPLIES_EXPERIENCE_ID = 'jira.user.smart_replies_feature.status';
export const RESOURCE_TYPE_SMART_REPLIES_STATUS = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';

export const PACKAGE_NAME = 'jiraIssueSmartRepliesPreferences';
